export default "__VITE_ASSET__CH2lMK64__"